import { useDataValue, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let change = useDataChange({
    context: 'task_description',
    viewPath: props.viewPath,
  })

  let description = useDataValue({
    context: 'task',
    path: 'description',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.description = description
    })
    setFlowTo(normalizePath(props.viewPath, '../Edit'))
  }
}

export function isNullText(value) {
  return value ?? ''
}
